import React, { useState } from "react";
import { RoomUnit } from "../../CreateUnit_Form/room_unit";
import styled from "styled-components/macro";
import { device } from "../../device";

const TuluUnitExpended = ({
  itemsCount,
  columns,
  colorUnit,
  logoImage,
  buildingName,
}) => {
  // const roomUnitRef = useRef();

  const [unitScale, setUnitScale] = useState();
  return (
    <Wrapper>
      <div style={{ flex: 1 }}>
        <TextWrapper>
          <MiniTitle>{`${buildingName}`}</MiniTitle>
          <Title>Your Building, Your TULU</Title>

          <ParaTwo>
            {
              "A complete physical and digital solution — both a self-contained unit and a smart app with countless options."
            }
          </ParaTwo>
          <ParaOne> tulu unit </ParaOne>
        </TextWrapper>
      </div>
      <UnitWrapper>
        <RoomUnit
          setUnitScale={setUnitScale}
          unitScale={unitScale}
          itemsCount={itemsCount}
          columns={columns}
          colorUnit={colorUnit}
          logoImage={logoImage}
        />
      </UnitWrapper>
    </Wrapper>
  );
};

export { TuluUnitExpended };

const Wrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding: 0 29px;
`;

const TextWrapper = styled.div`
  flex-direction: column;
  display: flex;
  position: relative;
  justify-content: center;
`;
const UnitWrapper = styled.div`
  display: flex;
  justify-content: center;
  @media ${device.mobileS} {
    margin-bottom: -460px;
  }
  @media ${device.tablet} {
    margin-bottom: 0px;
  }
`;

const MiniTitle = styled.p`
  font-weight: bold;
  font-family: "Lexend", serif;
  text-align: center;
  @media ${device.mobileS} {
    font-size: 20px;
    margin: 50px 0 0;
  }
  @media ${device.tablet} {
    margin: 82.3px 0 0;
    font-size: 50px;
  }
`;

const Title = styled.p`
  font-weight: bold;
  font-family: "Lexend", serif;
  margin: 20px 0 0;
  text-align: center;

  @media ${device.mobileS} {
    font-size: 24px;
  }
  @media ${device.tablet} {
    font-size: 50px;
  }
`;

const ParaOne = styled.p`
  /* font-size: 52px; */
  font-weight: bold;
  font-family: "Lexend", serif;
  margin: 0px;
  text-transform: uppercase;
  text-align: center;
  @media ${device.mobileS} {
    font-size: 20px;
    padding-bottom: 14.2px;
  }
  @media ${device.tablet} {
    font-size: 50px;
    padding-bottom: 38px;
  }
`;

const ParaTwo = styled.p`
  text-align: center;
  font-family: "DMSans", serif;
  white-space: pre-wrap;
  @media ${device.mobileS} {
    font-size: 15px;
    margin: 20px 0 40px;
  }
  @media ${device.tablet} {
    margin: 20px 0 71px;
    font-size: 20px;
    width: 580px;
    align-self: center;
  }
`;
